import React from 'react';
import ErrorPage from 'next/error';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import { useTranslation } from 'next-i18next';
import { useRouter } from 'next/router';
import { getPosts, getCategoriess } from '../../../utils/api/wordpress-api';
import ArticlesSubHeader from '../../../components/Articles/SubHeader';
import ArticlesMain from '../../../components/Articles/Main';
import BlogSEO from '../../../components/SEO/ForBlog';
import { checkLocaleAllowed } from '../../blog';

interface Props {
  posts: any;
  categories: any[];
  pageContext: any;
}

function Index({ posts: { edges }, categories, pageContext }: Props) {
  const { t } = useTranslation('blog');
  const router = useRouter();
  const { locale } = router;
  if (!checkLocaleAllowed(locale)) {
    return <ErrorPage statusCode={404} />;
  }

  return (
    <>
      <BlogSEO title={t('title.tag', { tag: pageContext.tag })} />
      <ArticlesSubHeader categories={categories} />
      <ArticlesMain posts={edges} pageContext={pageContext} locale={locale} />
    </>
  );
}

export async function getServerSideProps({
  preview = false,
  locale = 'en',
  query,
}) {
  const { tag } = query;
  const posts = await getPosts(
    {
      offset: 0,
      tag,
    },
    locale,
  );
  const categoriesData = await getCategoriess(locale);
  const basePath = '/blog/tag/[tag]';
  const baseAsPath = `/blog/tag/${tag}`;
  return {
    props: {
      ...(await serverSideTranslations(locale, ['common', 'blog'])),
      posts,
      preview,
      categories: categoriesData.categories,
      pageContext: {
        totalCount: posts.pageInfo.offsetPagination.total,
        limit: 10,
        skip: 0,
        filter: null,
        searchTerm: null,
        tag,
        basePath,
        baseAsPath,
      },
    },
  };
}

export default Index;
